// Copyright (c) 2016 Deere & Company

import './amount-of-use-history-panel.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import AmountOfUseHistoryPanelBody from './amount-of-use-history-panel-body';
import AmountOfUseHistoryPanelTitle from './amount-of-use-history-panel-title';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';

const AmountOfUseHistoryPanel = props =>
    <Accordion
        accordionId='amount-of-use-panel-accordion'
        body={<AmountOfUseHistoryPanelBody amountOfUseHistory={props.amountOfUseHistory}/>}
        isExpanded={props.isExpanded}
        onClick={props.onClick}
        title={<AmountOfUseHistoryPanelTitle count={props.amountOfUseHistory.length}/>}
    />;

AmountOfUseHistoryPanel.displayName = 'AmountOfUseHistoryPanel';
AmountOfUseHistoryPanel.propTypes = {
    amountOfUseHistory: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

export default AmountOfUseHistoryPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/amount-of-use-history-panel/index.js